import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy  } from '@angular/core';
import { CandidateStatusCount } from 'src/app/core/api.gen';


@Component({
  selector: 'eos-candidate-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './candidate-status.component.html'
})
export class CandidateStatusComponent implements OnInit {
  @Input() data: CandidateStatusCount[] =[];
  @Output() tileClick = new EventEmitter<number>();
  constructor() { }

  ngOnInit() {
  }

  onStatusClick(status: CandidateStatusCount, index: number) {
    this.tileClick.emit(status.statusId);
    this.data.forEach(count => count.selected = false);
    status.selected = true;
  }

}
